// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricingcarddata-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 2rem;
  justify-content: center;
  background-color: #f2f4f7;
}

.pricingcarddata-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  padding: 1.5rem;
  width: 100%;
  max-width: 320px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  position: relative;
}

.pricingcarddata-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.pricingcarddata-card h3 {
  font-size: 1.25rem;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
}

.pricingcarddata-card p {
  font-size: 0.95rem;
  color: #3d3d3d;
  margin: 0;
  line-height: 1.4;
}

.pricingcarddata-card p strong {
  color: #1a1a1a;
  font-weight: 600;
}

@media (max-width: 768px) {
  .pricingcarddata-card {
    max-width: 100%;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .pricingcarddata-card {
    max-width: 45%;
  }
}

@media (min-width: 1025px) {
  .pricingcarddata-card {
    max-width: 30%;
  }
}

.pricing_view_details_button {
  background-color: #3498db;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  text-align: center;
  text-decoration: none;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/Pricing/pricingexecutive.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;EACtC,YAAY;AACd","sourcesContent":[".pricingcarddata-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  padding: 2rem;\n  justify-content: center;\n  background-color: #f2f4f7;\n}\n\n.pricingcarddata-card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 320px;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  position: relative;\n}\n\n.pricingcarddata-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n}\n\n.pricingcarddata-card h3 {\n  font-size: 1.25rem;\n  color: #1a1a1a;\n  margin-bottom: 0.5rem;\n}\n\n.pricingcarddata-card p {\n  font-size: 0.95rem;\n  color: #3d3d3d;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.pricingcarddata-card p strong {\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .pricingcarddata-card {\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .pricingcarddata-card {\n    max-width: 45%;\n  }\n}\n\n@media (min-width: 1025px) {\n  .pricingcarddata-card {\n    max-width: 30%;\n  }\n}\n\n.pricing_view_details_button {\n  background-color: #3498db;\n  color: #fff;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  text-align: center;\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
